import { ShieldCheck } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const SECTIONS = [
  {
    title: "Deposits & cancellations",
    points: [
      "A flat $25 deposit secures your booking and is paid once CJ confirms your request.",
      "Cancel more than 24 hours before your appointment and your $25 deposit is refunded in full.",
      "Cancel within 24 hours of your appointment and the deposit is forfeited.",
      "You can cancel yourself anytime from the customer portal (My Bookings), or contact CJ directly.",
      "No-shows and failure to provide safe access on the day are treated as a late cancellation.",
    ],
  },
  {
    title: "Pricing",
    points: [
      "Listed prices are a guide based on vehicle size. Final pricing may vary based on your vehicle's condition.",
      "Heavily soiled interiors, set-in stains, or neglected paint may require extra time and incur an additional fee, quoted to you before any extra work begins.",
      "Excessive pet hair will always incur an additional fee if it is not mentioned when booking.",
      "The remaining balance is payable on completion of the work.",
    ],
  },
  {
    title: "Vehicle condition & access",
    points: [
      "The vehicle must be parked within 20 metres of a working garden tap and a power point.",
      "The vehicle must be free from excessive rubbish and personal belongings so we can clean effectively.",
      "Please remove valuables beforehand — CJ is not responsible for personal items left in the vehicle.",
      "Safe, legal and reasonable access to the vehicle must be available at the scheduled time.",
    ],
  },
  {
    title: "Damage & liability",
    points: [
      "The vehicle's condition is documented with photos before work begins — all damage must be documented.",
      "In the unlikely event that damage occurs to a vehicle during a detail, it will be handled directly by CJ.",
      "Pre-existing damage, defects, or wear (including paint, trim and upholstery) is not the responsibility of CJ.",
      "Results can vary with the age, material and prior care of the vehicle; a detail restores and protects but cannot guarantee removal of permanent defects.",
    ],
  },
  {
    title: "On the day",
    points: [
      "We detail on-site and come to you within the Skye / wider Melbourne service area.",
      "Appointment times are approximate; CJ will text an ETA and let you know if running behind.",
      "Severe weather may require rescheduling for your vehicle's best result — CJ will contact you.",
      "By booking you confirm you are the owner or are authorised to arrange detailing for the vehicle.",
    ],
  },
];

export default function Terms() {
  return (
    <div className="min-h-screen bg-[#0b0f17] text-slate-200">
      <Navbar />
      <section className="mx-auto max-w-3xl px-4 sm:px-6 py-16" data-testid="terms-page">
        <div className="h-12 w-12 rounded-xl bg-[#ff6b00]/10 flex items-center justify-center">
          <ShieldCheck className="h-6 w-6 text-[#ff6b00]" />
        </div>
        <div className="font-mono text-xs uppercase tracking-[0.25em] text-[#ff6b00] mt-5">The fine print</div>
        <h1 className="font-display mt-2 text-4xl sm:text-5xl font-extrabold uppercase tracking-tight text-slate-100">
          Terms &amp; Conditions
        </h1>
        <p className="mt-4 text-slate-400">
          Please read these terms before booking. Accepting them at checkout helps us give your car the best possible result — with no surprises for either of us.
        </p>

        <div className="mt-10 space-y-8">
          {SECTIONS.map((sec) => (
            <div key={sec.title} className="cj-card p-6" data-testid={`terms-section-${sec.title.toLowerCase().replace(/[^a-z]+/g, "-").replace(/^-|-$/g, "")}`}>
              <h2 className="font-display uppercase font-extrabold text-xl text-slate-100">{sec.title}</h2>
              <ul className="mt-3 space-y-2">
                {sec.points.map((p) => (
                  <li key={p} className="flex items-start gap-3 text-sm text-slate-300 leading-relaxed">
                    <span className="mt-2 h-1.5 w-1.5 rounded-full bg-[#ff6b00] shrink-0" />
                    <span>{p}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <p className="mt-10 text-xs text-slate-500 font-mono uppercase tracking-wider">
          Questions? Email cj.mobile.detailingse@gmail.com — CJ's Mobile Detailing.
        </p>
      </section>
      <Footer />
    </div>
  );
}
